<div class="mt-4" data-testid="evaluation-summary-table">
  @if (hasCharts()) {
    <div class="flex flex-wrap gap-4 mb-6" data-testid="summary-legend">
      @for (legendItem of legend(); track legendItem.type) {
        <div class="flex items-center gap-2" [attr.data-testid]="'legend-item-' + legendItem.type">
          <div
            class="w-3 h-3 rounded-full"
            [style.background-color]="legendItem.backgroundColor"
          ></div>
          <span class="text-sm">{{ legendItem.translationKey | transloco }}</span>
        </div>
      }
    </div>
    <div class="space-y-4" data-testid="summary-charts-container">
      @for (chart of charts(); track chart.ecNumber) {
        <div
          class="relative flex items-center p-3 bg-third-level rounded-sm gap-4"
          [attr.data-testid]="'summary-chart-ec-' + chart.ecNumber"
        >
          <span
            class="font-medium w-48 shrink-0"
            [attr.data-testid]="'chart-label-ec-' + chart.ecNumber"
            >{{ chart.translations | translateDirectus }}</span
          >
          <div class="flex-1 min-w-0">
            <app-evaluation-criteria-summary-chart
              [importanceScores]="chart.importanceScores"
              [attr.data-testid]="'chart-canvas-ec-' + chart.ecNumber"
            />
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="text-center py-8" data-testid="no-attributes-message">
      <i class="pi pi-info-circle text-4xl text-gray-400 mb-4"></i>
      <h3 class="text-lg font-semibold text-gray-600 mb-2">
        {{ 'project.steps.evaluationCriteria.summary.noCompletedEvaluationsTitle' | transloco }}
      </h3>
      <p class="text-gray-500">
        {{ 'project.steps.evaluationCriteria.summary.noCompletedEvaluationsMessage' | transloco }}
      </p>
    </div>
  }
</div>
